




















import { Component, Prop, Vue } from 'vue-property-decorator'
import { BracketScoreResult } from '@/api/stage'

@Component({
  name: 'BracketTeam'
})
export default class BracketTeam extends Vue {
  @Prop({ type: Boolean, default: false }) readonly empty!: boolean
  @Prop({ type: String, default: '' }) readonly BracketTeamName!: string
  @Prop({ type: Number, default: -1 }) readonly score!: number
  @Prop({ type: String, default: BracketScoreResult.None })
  readonly result!: BracketScoreResult
  @Prop({ type: Boolean, default: false }) readonly hovered!: boolean
  @Prop({ type: Boolean, default: false }) readonly alwaysDisplayScore!: boolean

  get initial() {
    return this.BracketTeamName.substr(0, 1).toUpperCase()
  }

  get displayScoreText() {
    if (
      this.alwaysDisplayScore &&
      [
        BracketScoreResult.Win,
        BracketScoreResult.Lose,
        BracketScoreResult.Draw
      ].includes(this.result)
    ) {
      return this.score
    }

    if (
      (this.result === BracketScoreResult.Win && this.score > 0) ||
      this.result === BracketScoreResult.Lose
    ) {
      return this.score
    }

    return this.$t(`BracketScoreResult.${this.result.toString()}`)
  }

  get isWinner() {
    return this.result === BracketScoreResult.Win
  }
}
